import { User } from "@impacgroup/angular-oauth-base";
import { BreakoutGroup } from "./BreakoutGroup";

export class BreakoutGroupUser extends User {
    assignedBreakoutGroup?: BreakoutGroup;
    selectedBreakoutGroups: BreakoutGroup[];
    checked: Boolean;
}
